import { NavLink, Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { EASE } from "@/components/shared/motion";

export const NAV_LINKS = [
  { label: "Work", to: "/work" },
  { label: "Capabilities", to: "/capabilities" },
  { label: "Experiments", to: "/experiments" },
  { label: "About", to: "/about" },
];

const SHEET_HIDDEN = { opacity: 0, y: -12 };
const SHEET_SHOWN = { opacity: 1, y: 0 };
const SHEET_TRANSITION = { duration: 0.35, ease: EASE };

const linkClass = ({ isActive }) =>
  `group relative font-mono text-[11px] uppercase tracking-[0.25em] transition-colors duration-300 focus-visible:outline-none focus-visible:text-[#F4F6FB] ${
    isActive ? "text-[#F4F6FB]" : "text-[#F4F6FB]/60 hover:text-[#F4F6FB]"
  }`;

export const NavLinks = () => (
  <ul className="hidden items-center gap-7 lg:flex">
    {NAV_LINKS.map((link) => (
      <li key={link.label}>
        <NavLink
          to={link.to}
          data-testid={`nav-link-${link.label.toLowerCase()}`}
          className={linkClass}
        >
          {link.label}
          <span className="absolute -bottom-1 left-0 h-px w-0 bg-gradient-to-r from-[#8B5CF6] to-[#06B6D4] transition-[width] duration-300 group-hover:w-full" />
        </NavLink>
      </li>
    ))}
  </ul>
);

export const NavMobileSheet = ({ open, onClose, onStart }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        data-testid="nav-mobile-sheet"
        initial={SHEET_HIDDEN}
        animate={SHEET_SHOWN}
        exit={SHEET_HIDDEN}
        transition={SHEET_TRANSITION}
        className="mt-3 overflow-hidden rounded-3xl border border-white/10 bg-[#12141C]/90 p-6 shadow-[0_20px_60px_rgba(0,0,0,0.6)] backdrop-blur-2xl lg:hidden"
      >
        <ul className="space-y-5">
          {NAV_LINKS.map((link) => (
            <li key={link.label}>
              <NavLink
                to={link.to}
                onClick={onClose}
                data-testid={`nav-mobile-link-${link.label.toLowerCase()}`}
                className="font-display block text-2xl font-semibold text-[#F4F6FB]"
              >
                {link.label}
              </NavLink>
            </li>
          ))}
          <li>
            <Link
              to="/start-a-project"
              onClick={onStart}
              data-testid="nav-mobile-start-project"
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#06B6D4]"
            >
              Start a Project →
            </Link>
          </li>
        </ul>
      </motion.div>
    )}
  </AnimatePresence>
);
